module.exports = __webpack_public_path__ + "static/media/sleepyDragon.2dc2b01c.png";